import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAudienceSyncPlatformAdAccountsAdAccountIdAudiencesCacheKeys: AllRouteEndpoints[] = [
  "/engagement/audience_sync/:platform/ad_accounts",
];
